import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { LanguageProvider } from "./context/LanguageContext.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./index.css";

// Prerendered static pages (per scripts/prerender.ts) ship their own HTML
// inside <div id="root">. The React app would overwrite it on mount, so we
// strip the prerendered stub first; the visible DOM for those routes comes
// from prerender until hydration paints over it.
const PRERENDERED_PREFIXES = ["/en", "/articles", "/videos", "/quiz", "/haftkhan"];
const pathname = typeof window !== "undefined" ? window.location.pathname : "/";
const isPrerendered = PRERENDERED_PREFIXES.some(
  (p) => pathname === p || pathname.startsWith(p + "/"),
);
if (isPrerendered) {
  const rootEl = document.getElementById("root");
  if (rootEl) rootEl.innerHTML = "";
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <ErrorBoundary>
          <App />
       </ErrorBoundary>
     </LanguageProvider>
   </BrowserRouter>
 </StrictMode>,
);
